import * as z from 'zod';

export const GetMemberPrivacySettingsRequest = z.object({});
export const GetMemberPrivacySettingsResponse = z.object({
  memberPrivacySettings: z
    .object({
      _id: z
        .string()
        .describe('Member privacy settings ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      publicMemberVisibility: z
        .enum(['UNKNOWN', 'VISIBLE_TO_MEMBERS_ONLY', 'VISIBLE_TO_ALL'])
        .describe('Who can see the public member profiles.')
        .optional(),
      publicMemberCandidates: z
        .enum(['UNKNOWN', 'NO_ONE', 'ANYONE'])
        .describe('Who can make the member profile public.')
        .optional(),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Revision number, which increments by 1 each time the member privacy settings are updated. To prevent conflicting changes, the existing revision must be used when updating member privacy settings.'
        )
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe(
          'Date and time when the member privacy settings were updated.'
        )
        .optional()
        .nullable(),
    })
    .describe('Retrieved member privacy settings.')
    .optional(),
});
export const SetMemberPrivacySettingsRequest = z.object({
  memberPrivacySettings: z
    .object({
      _id: z
        .string()
        .describe('Member privacy settings ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      publicMemberVisibility: z
        .enum(['UNKNOWN', 'VISIBLE_TO_MEMBERS_ONLY', 'VISIBLE_TO_ALL'])
        .optional(),
      publicMemberCandidates: z
        .enum(['UNKNOWN', 'NO_ONE', 'ANYONE'])
        .optional(),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Revision number, which increments by 1 each time the member privacy settings are updated. To prevent conflicting changes, the existing revision must be used when updating member privacy settings.'
        ),
      _updatedDate: z
        .date()
        .describe(
          'Date and time when the member privacy settings were updated.'
        )
        .optional()
        .nullable(),
    })
    .describe('Member privacy settings details.'),
});
export const SetMemberPrivacySettingsResponse = z.object({
  memberPrivacySettings: z
    .object({
      _id: z
        .string()
        .describe('Member privacy settings ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      publicMemberVisibility: z
        .enum(['UNKNOWN', 'VISIBLE_TO_MEMBERS_ONLY', 'VISIBLE_TO_ALL'])
        .describe('Who can see the public member profiles.')
        .optional(),
      publicMemberCandidates: z
        .enum(['UNKNOWN', 'NO_ONE', 'ANYONE'])
        .describe('Who can make the member profile public.')
        .optional(),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Revision number, which increments by 1 each time the member privacy settings are updated. To prevent conflicting changes, the existing revision must be used when updating member privacy settings.'
        )
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe(
          'Date and time when the member privacy settings were updated.'
        )
        .optional()
        .nullable(),
    })
    .describe('Member privacy settings.')
    .optional(),
});
